/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Wrapped_Summary_PillInputs */

const en_us2_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Summary · ${i?.range}`)
};

const pt_br2_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resumo · ${i?.range}`)
};

const es_419_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resumen · ${i?.range}`)
};

const pt_pt2_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resumo · ${i?.range}`)
};

const fr_fr2_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Résumé · ${i?.range}`)
};

const de_de2_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zusammenfassung · ${i?.range}`)
};

const it_it2_wrapped_summary_pill = /** @type {(inputs: Wrapped_Summary_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riepilogo · ${i?.range}`)
};

/**
* | output |
* | --- |
* | "Summary · {range}" |
*
* @param {Wrapped_Summary_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_summary_pill = /** @type {((inputs: Wrapped_Summary_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Summary_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_summary_pill(inputs)
	if (locale === "es-419") return es_419_wrapped_summary_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_summary_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_summary_pill(inputs)
	if (locale === "de-DE") return de_de2_wrapped_summary_pill(inputs)
	if (locale === "it-IT") return it_it2_wrapped_summary_pill(inputs)
	return en_us2_wrapped_summary_pill(inputs)
});
export { wrapped_summary_pill as "wrapped.summary_pill" }